import { Component, OnInit, inject } from '@angular/core';
import { ReportingService } from '../../reporting.service';

@Component({
    selector: 'app-load-history',
    templateUrl: './load-history.component.html',
    styleUrls: ['./load-history.component.scss'],
    standalone: false
})
export class LoadHistoryComponent implements OnInit {
  private rptSvc = inject(ReportingService);

  loadHistoryData;

  ngOnInit(): void {
    this.getHistory();
  }

  getHistory() {
    this.rptSvc.getLoadHistory().subscribe({
      next: data => {
        this.loadHistoryData = { ...data.results };
      },
      error: error => {
        console.error(error);
      },
    });
  }
}
